import { socket } from "../App";
import { SOCKET, socketPairTopicPrefix } from "../constants/constants";

/** Last pair room + join payload tracked from React layer. */
const roomContext = {
  pair_key: "",
  userId: "",
};

const postJoinSubscribers = new Set();

/** Fire after joinRoom emits while connected — for REST reconciliation (order book snapshot, etc.). */
function notifyPostJoinSubscribers() {
  postJoinSubscribers.forEach((cb) => {
    try {
      cb();
    } catch (err) {
      console.warn("[exchangePairRoomSocket] post-join subscriber failed", err);
    }
  });
}

function emitJoinIfReady() {
  const prefix = socketPairTopicPrefix(roomContext.pair_key);
  if (!prefix || !socket.connected) return false;
  try {
    socket.emit(SOCKET.JOIN_ROOM, {
      room: prefix,
      userId: roomContext.userId ?? "",
    });
    console.log("[exchangePairRoomSocket] emitted joinRoom (post-join listeners will run)", {
      room: prefix,
      hasUserId: Boolean(roomContext.userId),
      connected: socket.connected,
    });
    notifyPostJoinSubscribers();
    return true;
  } catch (err) {
    console.warn("[exchangePairRoomSocket] joinRoom emit failed", err);
    return false;
  }
}

let connectListenerBound = false;

function bindConnectListenerOnce() {
  if (connectListenerBound) return;
  connectListenerBound = true;
  console.log("[exchangePairRoomSocket] listening on socket connect for re-join");
  socket.on("connect", () => {
    emitJoinIfReady();
  });
}

/**
 * Called when active pair or user context changes — and once from Exchange on mount.
 * Ensures exactly one authoritative joinRoom path + reconnect semantics.
 *
 * userInfo — same shape as SocketHook historically used ({ user_id }).
 */
export function syncExchangePairRoom(pair_key, userInfo) {
  bindConnectListenerOnce();

  roomContext.pair_key =
    typeof pair_key === "string" && pair_key.trim() !== "" ? pair_key : "";

  roomContext.userId =
    userInfo != null && userInfo.user_id != null ? String(userInfo.user_id) : "";

  emitJoinIfReady();
}

/**
 * Registers a callback after each successful pair-room join (including reconnect).
 * Returns unsubscribe — use inside useEffect cleanup.
 */
export function registerExchangePairPostJoin(onPostJoin) {
  if (typeof onPostJoin !== "function") {
    return () => {};
  }
  postJoinSubscribers.add(onPostJoin);
  return () => postJoinSubscribers.delete(onPostJoin);
}
